/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import React from "react"
import { Button } from "react-bootstrap"
import { Sentry } from "services/sentry"

const SentryTestButton: React.FC = () => {
  const [shouldError, setShouldError] = React.useState(false)

  const testSentryError = () => {
    // Test manual error capture
    Sentry.captureException(new Error("Test error from Sentry integration"))

    // Trigger a render error (will be caught by error boundary)
    setShouldError(true)
  }

  // This will cause a render error that the error boundary can catch
  if (shouldError) {
    throw new Error("Test error boundary capture")
  }

  const testSentryMessage = () => {
    Sentry.captureMessage("Test message from Sentry integration", "info")
    alert("Test message sent to Sentry!")
  }

  const testPerformance = () => {
    // Modern Sentry v9+ approach - simpler performance tracking
    void Sentry.startSpan(
      {
        name: "Test Operation",
        op: "test",
      },
      () => {
        // Simulate some work
        return new Promise(resolve => {
          setTimeout(() => {
            alert("Performance span completed!")
            resolve(undefined)
          }, 1000)
        })
      }
    )
  }

  // Only show in development
  if (import.meta.env.VITE_MODE === "production") {
    return null
  }

  return (
    <div className="p-3 border rounded bg-light mb-3">
      <h5>Sentry Testing (Development Only)</h5>
      <p className="small text-muted">
        These buttons are only visible in development mode to test Sentry integration.
      </p>
      <div className="d-flex gap-2 flex-wrap">
        <Button variant="danger" size="sm" onClick={testSentryError}>
          Test Error Capture
        </Button>
        <Button variant="info" size="sm" onClick={testSentryMessage}>
          Test Message
        </Button>
        <Button variant="success" size="sm" onClick={testPerformance}>
          Test Performance
        </Button>
      </div>
    </div>
  )
}

export default SentryTestButton
